import { render, staticRenderFns } from "./ProveedorTiemposEntrega.vue?vue&type=template&id=32f3676a&scoped=true&"
import script from "./ProveedorTiemposEntrega.vue?vue&type=script&lang=js&"
export * from "./ProveedorTiemposEntrega.vue?vue&type=script&lang=js&"
import style0 from "./ProveedorTiemposEntrega.vue?vue&type=style&index=0&id=32f3676a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3676a",
  null
  
)

export default component.exports